import { get } from 'js/utils/fetch.util';
import { useDispatch } from 'react-redux';
import { prop } from 'js/utils/ramda.util';
import { useCallback, useState } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import * as actions from '../../../../../../store/actions';

export const useGetSidebarData = () => {
    const dispatch = useDispatch();
    const isMounted = useIsMounted();
    const lang = useUserSelector(prop('lang'));
    const [isLoading, setIsLoading] = useState(true);
    const requestStamp = useAppSelector(prop('requestStamp'));

    const request = useCallback(async () => {
        if (!lang) {
            return;
        }

        isMounted() && setIsLoading(true);

        return get(`/sideBar/${lang}?t=${requestStamp || Date.now()}`)
            .then((response) => {
                dispatch(actions.updateSidebarData(helpers.parseMenuResponse(response)));
            })
            .finally(() => isMounted() && setIsLoading(false));
    }, [dispatch, isMounted, lang, requestStamp]);

    return [request, isLoading];
};
